document.addEventListener("DOMContentLoaded",  () => {
  const cgAccordionContent = document.querySelector(".cg-tab-content-edit");
  const cgAccordionBtn = document.querySelector(".cg-tab-title");
  const cgAccordionContent2 = document.querySelector(".cg-tab-content-edit2");
  const cgAccordionBtn2 = document.querySelector(".cg-tab-title2");
  const cgAccordionContent3 = document.querySelector(".cg-tab-content-edit3");
  const cgAccordionBtn3 = document.querySelector(".cg-tab-title3");
  
  const toggleAccordionCg = (content) => {
    if (content.style.display === "block") {
      content.style.display = "none"
    } else {
      content.style.display = "block"
    }
  }
  
  if( cgAccordionBtn) {
    cgAccordionBtn.onclick = () => toggleAccordionCg(cgAccordionContent)

  }
  if(cgAccordionBtn2) {
    cgAccordionBtn2.onclick = () => toggleAccordionCg(cgAccordionContent2)
 
  }
  if (cgAccordionBtn3) {
    cgAccordionBtn3.onclick = () => toggleAccordionCg(cgAccordionContent3)
 
  }

  
})


/*   if( cgAccordionBtn) {
    cgAccordionBtn.onclick = () => toggleAccordionCg(cgAccordionContent)
    cgAccordionContent.style.display = "none";
  }
  if(cgAccordionBtn2) {
    cgAccordionBtn2.onclick = () => toggleAccordionCg(cgAccordionContent2)
    cgAccordionContent2.style.display = "none";
  }
  if (cgAccordionBtn3) {
    cgAccordionBtn3.onclick = () => toggleAccordionCg(cgAccordionContent3)
    cgAccordionContent3.style.display = "none";
  }
 */






















